'use client';
import { useI18n } from '@/components/public/i18n/LocaleProvider';
import type { ElinaProject } from '@/lib/public/elina-contract';
import { proposalAmbition, proposalSections } from '@/lib/public/proposal-content';
import './proposal.css';

export default function ProposalDocument({ project: p, commercial = false }: { project: ElinaProject; commercial?: boolean }) {
  const { t, href, content, locale } = useI18n();


  return <article className="elina-document" aria-label={t("Proposition de solution non chiffrée")}>
    <p className="elina-document-label">{commercial ? t('Version relue et transmise par le prospect') : t('Votre proposition de solution · Sans chiffrage')}</p>
    <header className="elina-document-opening">
      <h2>{proposalAmbition(p, locale)}</h2>
      {p.recommendation && <div className="elina-document-recommendation"><p className="elina-document-label">{t("La réponse RDV-Partners")}</p><p>{p.recommendation}</p></div>}
    </header>
    {proposalSections(p, locale).map(section => <section key={section.kind} className={`elina-document-${section.kind}`}>
      <h3><span>{section.number}</span> {section.title}</h3>
      <div className="elina-document-cards">{section.cards.map((card, i) => <div key={i}>
        {card.title && <h4>{card.title}</h4>}
        <p>{card.text}</p>
        {card.value && <p className="elina-document-value"><strong>{t("Bénéfice direct :")}</strong> {card.value}</p>}
      </div>)}</div>
      {section.note && <p className="elina-document-note">{section.note}</p>}
    </section>)}
  </article>;
}

